import { LoaderMask } from 'components/LoaderMask/LoaderMask';
import { useAsyncEffect } from 'customHooks/hooks';
import React, { ReactElement, useContext } from 'react';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { BenchmarkOverallSatisfactionText } from 'screens/WidgetGenerator/widgets/BenchmarkWidgets/BenchmarkOverallSatisfactionText/BenchmarkOverallSatisfactionText';
import { fetchBenchmarkCycleExecutions } from 'services/benchmarkCycleExecutions';
import { getBenchmarkOverallSatisfactionData } from 'services/benchmarkScores';
import { Nullable, SelectedDateRange } from 'types/misc';
import { logger } from 'utils/logger';

export const BenchmarkOverallSatisfactionTextHOC = (): ReactElement => {
  const { client } = useContext(WidgetGeneratorContext);
  const [benchmarkLastCycle, setBenchmarkLastCycle] = React.useState<Nullable<SelectedDateRange>>(null);

  const selectedBenchmarkClient = client;

  const fetchOverallSatisfactionWidgetData = async () => {
    if (!selectedBenchmarkClient) {
      return null;
    }

    const fetchedBenchmarkCycles = await fetchBenchmarkCycleExecutions();
    const parsedBenchmarkCycles = fetchedBenchmarkCycles.map((benchmarkCycle) => ({
      startDate: benchmarkCycle.start_date,
      endDate: benchmarkCycle.end_date,
      value: benchmarkCycle.id.toString(),
    }));

    const selectedDateRange = parsedBenchmarkCycles[0];
    setBenchmarkLastCycle(selectedDateRange);

    const fetchedData = await getBenchmarkOverallSatisfactionData(selectedBenchmarkClient, selectedDateRange);
    return fetchedData;
  };

  const {
    fetchedData: overallSatisfactionData,
    isLoading,
    error,
  } = useAsyncEffect(fetchOverallSatisfactionWidgetData, [selectedBenchmarkClient]);

  if (error) {
    logger.error(error);
  }

  if (!overallSatisfactionData || !benchmarkLastCycle) {
    return <></>;
  }

  return (
    <LoaderMask isLoading={isLoading}>
      <BenchmarkOverallSatisfactionText
        widgetData={overallSatisfactionData}
        selectedClient={selectedBenchmarkClient}
        selectedDateRange={benchmarkLastCycle}
      />
    </LoaderMask>
  );
};
